import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { AgingScreen } from '@/features/accounting-reports/aging-screen'
import { type ReportSearch, reportSearchFrom } from '@/features/accounting-reports/api'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/aging')({
  validateSearch: (search: Record<string, unknown>): ReportSearch => reportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AgingRoute,
})

function AgingRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <AgingScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/accounting/reports/aging', search: next })}
    />
  )
}
